import { parse } from 'date-fns';
import { find, isEmpty, isUndefined, includes, trim, forEach } from 'lodash';
import moment from 'moment';

import { store } from '~/store';
import { modifyTitle } from '~/store/modules/drawer/actions';

/**
 * modify title page
 *
 * @param {String} param
 */
export async function title(param) {
  await store.dispatch(modifyTitle(param));
}

/**
 * translation found in the system
 *
 * @param {String} param
 */
export function t(param) {
  const { translate } = store.getState().language;

  const objTranslated = find(
    translate,
    (trans) => trans.codigolabelsistema === param
  );

  if (!isUndefined(objTranslated) && !isEmpty(objTranslated)) {
    return objTranslated.textoidiomalabelsistema;
  }

  return param;
}

/**
 * convert type to filter system
 *
 * @param {String} type
 */
export function convertType(type) {
  switch (type) {
    case 'text':
    default:
      return 'LIKE';
    case 'number':
    case 'select':
    case 'autocomplete':
      return 'EQUALS';
    case 'initialdatetime':
    case 'initialdate':
    case 'initialhour':
      return 'MAIOR_IGUAL';
    case 'finaldatetime':
    case 'finaldate':
    case 'finalhour':
      return 'MENOR_IGUAL';
  }
}

/**
 * difference between them
 *
 * @param {Array} newArr
 * @param {Array} origin
 */
export function differenceBetween(newArr, origin) {
  return origin.filter((row) => !includes(newArr, row));
}

/**
 * user permission
 *
 * @param {Int} permission
 */
export function can(permission) {
  const { modules } = store.getState().user;

  return includes(modules, permission);
}

/**
 * Convert timestamp in date
 *
 * @param {String} timestamp
 * @param {Boolean} time
 */
export function timestampToDate(timestamp, time = false) {
  const locale = 'pt-BR';

  if (time) {
    return new Date(timestamp).toLocaleString(locale);
  }

  return new Date(timestamp).toLocaleDateString(locale);
}

/**
 * Nova função para tratamento de altura e volume de arqueação
 *
 * @param {string} value
 * @param {number} altura
 * @param {number} vol
 */
export function arqueacaoAlturaVolume(value, altura, vol) {
  let error;

  const items = value.trim().split('\n');

  forEach(items, (item, index) => {
    const values = item.trim().split(';');

    const height = parseFloat(values[0]);
    const volume = parseFloat(values[1]);

    if (height < 0 || volume < 0)
      error = 's.configuracao.arqueacao.itens.naopodesernegativo';

    if (height > altura)
      error =
        's.configuracao.arqueacao.itens.valorfinaldeveserigualaoamaioraltura';

    if (volume > vol)
      error =
        's.configuracao.arqueacao.itens.volumefinaldeveserigualaaomaiorvolume';

    if (index > 0) {
      const previous = items[index - 1].trim().split(';');

      const previousHeight = parseFloat(previous[0]);
      const previousVolume = parseFloat(previous[1]);

      if (height <= previousHeight)
        error = `A altura ${height} deve ser maior que a altura anterior.`;

      if (volume <= previousVolume)
        error = `O volume ${volume} deve ser maior que o volume anterior.`;
    }
  });

  return error;
}

/**
 * Verifica a composicao de altura e volume da arqueacao.
 *
 * @param {String} value
 * @param {String} alturaMaximaArqueacao
 * @param {String} volumeMaximoArqueacao
 */
export function alturaVolume(
  value,
  alturaMaximaArqueacao,
  volumeMaximoArqueacao
) {
  if (alturaMaximaArqueacao && volumeMaximoArqueacao) {
    const height = value.trim().split('\n');
    const initials = height[0];
    const finals = height[height.length - 1];

    const initialVolume = initials.trim().split(';');
    const finalValume = finals.trim().split(';');

    if (parseInt(initialVolume[0]) < 0 || parseInt(initialVolume[1]) < 0) {
      return 's.configuracao.arqueacao.itens.naopodesernegativo';
    }

    if (parseInt(alturaMaximaArqueacao) !== parseInt(finalValume[0])) {
      return 's.configuracao.arqueacao.itens.valorfinaldeveserigualaoamaioraltura';
    }

    if (parseInt(volumeMaximoArqueacao) !== parseInt(finalValume[1])) {
      return 's.configuracao.arqueacao.itens.volumefinaldeveserigualaaomaiorvolume';
    }
  }

  return undefined;
}

/**
 * valid characters
 *
 * @param {String} value
 */
export function validCharacters(value) {
  if (!isEmpty(trim(value))) {
    return /^[a-zA-Z0-9-._() ]+$/.test(value);
  }

  return true;
}

/**
 * search URL in array navigations
 *
 * @param {Array} navs
 * @param {String} url
 */
function searchURLToNavigations(navs, url) {
  const node = navs
    .map((nav) => {
      if (nav.rotamenu === url) return nav.codigotarefa;

      if (!isEmpty(nav.submenus)) {
        const desiredNode = searchURLToNavigations(nav.submenus, url);

        if (desiredNode) return desiredNode;
      }

      return false;
    })
    .filter((e) => e.length)
    .toString();

  return node;
}

/**
 * permission to URL
 */
export function canURL() {
  const { navigations } = store.getState().drawer;
  const getURL = window.location.pathname;

  const URLNavigation = searchURLToNavigations(navigations, getURL).split(',');
  const crud = {};

  URLNavigation.map((url) => {
    switch (url) {
      case 'POST':
        crud.create = true;
        break;
      case 'GET':
        crud.read = true;
        break;
      case 'SEARCH':
        crud.search = true;
        break;
      case 'PUT':
        crud.update = true;
        break;
      case 'DELETE':
        crud.delete = true;
        break;
      case 'VAZEMABAST':
        crud.vazemabast = true;
        break;
      case 'VAZEMTRANSF':
        crud.vazemtransf = true;
        break;
      case 'POST_COTA':
        crud.post_cota = true;
        break;
      case 'DELETE_COT':
        crud.delete_cota = true;
        break;
      case 'PUT_COTA':
        crud.put_cota = true;
        break;
      default:
    }

    return true;
  });

  return crud;
}

/**
 * convert array to filter URL
 *
 * @param {Array} fields
 */
export function filterSerialize(fields) {
  const wherefield = [];
  const valuewherefield = [];
  const typewherefield = [];

  fields.map((field) => {
    const { name, type, value } = field;
    let defValue = value;

    if (!isEmpty(trim(value))) {
      if (includes(['datetime', 'initialdatetime', 'finaldatetime'], type)) {
        const initialDate = moment(value);

        switch (type) {
          case 'initialdatetime':
            initialDate.set({ seconds: 0 });
            break;
          case 'finaldatetime':
            initialDate.set({ seconds: 59 });
            break;
          default:
            break;
        }

        defValue = initialDate.format('DD/MM/YYYY HH:mm:ss');
      }

      wherefield.push(name);
      valuewherefield.push(defValue);
      typewherefield.push(type);
    }

    return true;
  });

  return { wherefield, valuewherefield, typewherefield };
}

/**
 * convert number to locale
 *
 * @param {Number} value
 * @param {String} options
 */
export function number(value = 0.0, options = '0') {
  const { language } = store.getState().user;

  let style = {};
  let currency = '';

  // change currence coin
  switch (language) {
    case 'pt-BR':
      currency = 'BRL';
      break;
    case 'en-US':
    default:
      currency = 'USD';
      break;
  }

  // added options in formar value
  switch (options) {
    // coin
    case 'currency':
      style = { style: 'currency', currency };
      break;
    case 'priceproduct':
      style = {
        style: 'currency',
        currency,
        currencymaximumFractionDigits: Number(4),
        minimumFractionDigits: Number(4),
      };
      break;
    default:
      style = {
        maximumFractionDigits: Number(options),
        minimumFractionDigits: Number(options),
      };
      break;
  }

  return parseFloat(value).toLocaleString(language, style);
}

export function parseDateString(value, format = 'dd/MM/yyyy HH:mm:ss') {
  return parse(value, format, new Date());
}

export function parseOnlyDateString(value, format = 'dd/MM/yyyy') {
  return parse(value, format, new Date());
}
